/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio Monitoring API
 * A comprehensive portfolio monitoring and reporting tool for DeFi users to track investments/balances across multiple protocols, discover yield opportunities, and generate reports for tax and accounting purposes.  The API enables users to: - Monitor balances and earnings across lending, liquid staking, LP positions, vaults, and traditional staking - Discover new yield opportunities with advanced filtering and sorting - Generate downloadable reports for taxes, accounting, and personal tracking - Aggregate data at multiple levels (combined, by category, by protocol, by wallet) - Track performance over time with historical data
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setSearchParams, toPathString, createRequestFunction } from '../common.js';
// @ts-ignore
import { BASE_PATH, BaseAPI, operationServerMap } from '../base.js';
/**
 * WalletInsightsApi - axios parameter creator
 */
export const WalletInsightsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Retrieve the balance for a specific wallet with fiat values and native token balances
         * @summary Get wallet balance
         * @param {string} address Wallet address or UUID
         * @param {Array<string>} [chainIDs] Filter by specific chain IDs (e.g., eip155:1, eip155:10)
         * @param {Array<FiatType>} [fiatType] Fiat currency to quote any fiat pricing in
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWalletBalance: async (address, chainIDs, fiatType, options = {}) => {
            // verify required parameter 'address' is not null or undefined
            assertParamExists('getWalletBalance', 'address', address);
            const localVarPath = `/portfolio/v1/wallet/{address}/balance`
                .replace(`{${"address"}}`, encodeURIComponent(String(address)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (chainIDs) {
                localVarQueryParameter['chainIDs'] = chainIDs;
            }
            if (fiatType) {
                localVarQueryParameter['fiatType'] = fiatType;
            }
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve the transactions for a specific wallet
         * @summary Get wallet transactions
         * @param {string} address Wallet address or UUID
         * @param {Array<string>} [chainIDs] Filter by specific chain IDs (e.g., eip155:1, eip155:10)
         * @param {string} [pageToken] Token for pagination to get the next page of results
         * @param {number} [limit] Number of records to return per page
         * @param {Array<FiatType>} [fiatType] Fiat currency to quote any fiat pricing in
         * @param {GetWalletTransactionsTransactionVerbosityEnum} [transactionVerbosity] Option for verbosity of transaction data returned
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWalletTransactions: async (address, chainIDs, pageToken, limit, fiatType, transactionVerbosity, options = {}) => {
            // verify required parameter 'address' is not null or undefined
            assertParamExists('getWalletTransactions', 'address', address);
            const localVarPath = `/portfolio/v1/wallet/{address}/transactions`
                .replace(`{${"address"}}`, encodeURIComponent(String(address)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            if (chainIDs) {
                localVarQueryParameter['chainIDs'] = chainIDs;
            }
            if (pageToken !== undefined) {
                localVarQueryParameter['pageToken'] = pageToken;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (fiatType) {
                localVarQueryParameter['fiatType'] = fiatType;
            }
            if (transactionVerbosity !== undefined) {
                localVarQueryParameter['transactionVerbosity'] = transactionVerbosity;
            }
            localVarHeaderParameter['Accept'] = 'application/json';
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * WalletInsightsApi - functional programming interface
 */
export const WalletInsightsApiFp = function (configuration) {
    const localVarAxiosParamCreator = WalletInsightsApiAxiosParamCreator(configuration);
    return {
        /**
         * Retrieve the balance for a specific wallet with fiat values and native token balances
         * @summary Get wallet balance
         * @param {string} address Wallet address or UUID
         * @param {Array<string>} [chainIDs] Filter by specific chain IDs (e.g., eip155:1, eip155:10)
         * @param {Array<FiatType>} [fiatType] Fiat currency to quote any fiat pricing in
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWalletBalance(address, chainIDs, fiatType, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWalletBalance(address, chainIDs, fiatType, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WalletInsightsApi.getWalletBalance']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieve the transactions for a specific wallet
         * @summary Get wallet transactions
         * @param {string} address Wallet address or UUID
         * @param {Array<string>} [chainIDs] Filter by specific chain IDs (e.g., eip155:1, eip155:10)
         * @param {string} [pageToken] Token for pagination to get the next page of results
         * @param {number} [limit] Number of records to return per page
         * @param {Array<FiatType>} [fiatType] Fiat currency to quote any fiat pricing in
         * @param {GetWalletTransactionsTransactionVerbosityEnum} [transactionVerbosity] Option for verbosity of transaction data returned
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWalletTransactions(address, chainIDs, pageToken, limit, fiatType, transactionVerbosity, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWalletTransactions(address, chainIDs, pageToken, limit, fiatType, transactionVerbosity, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['WalletInsightsApi.getWalletTransactions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * WalletInsightsApi - factory interface
 */
export const WalletInsightsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = WalletInsightsApiFp(configuration);
    return {
        /**
         * Retrieve the balance for a specific wallet with fiat values and native token balances
         * @summary Get wallet balance
         * @param {string} address Wallet address or UUID
         * @param {Array<string>} [chainIDs] Filter by specific chain IDs (e.g., eip155:1, eip155:10)
         * @param {Array<FiatType>} [fiatType] Fiat currency to quote any fiat pricing in
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWalletBalance(address, chainIDs, fiatType, options) {
            return localVarFp.getWalletBalance(address, chainIDs, fiatType, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve the transactions for a specific wallet
         * @summary Get wallet transactions
         * @param {string} address Wallet address or UUID
         * @param {Array<string>} [chainIDs] Filter by specific chain IDs (e.g., eip155:1, eip155:10)
         * @param {string} [pageToken] Token for pagination to get the next page of results
         * @param {number} [limit] Number of records to return per page
         * @param {Array<FiatType>} [fiatType] Fiat currency to quote any fiat pricing in
         * @param {GetWalletTransactionsTransactionVerbosityEnum} [transactionVerbosity] Option for verbosity of transaction data returned
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWalletTransactions(address, chainIDs, pageToken, limit, fiatType, transactionVerbosity, options) {
            return localVarFp.getWalletTransactions(address, chainIDs, pageToken, limit, fiatType, transactionVerbosity, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * WalletInsightsApi - object-oriented interface
 */
export class WalletInsightsApi extends BaseAPI {
    /**
     * Retrieve the balance for a specific wallet with fiat values and native token balances
     * @summary Get wallet balance
     * @param {string} address Wallet address or UUID
     * @param {Array<string>} [chainIDs] Filter by specific chain IDs (e.g., eip155:1, eip155:10)
     * @param {Array<FiatType>} [fiatType] Fiat currency to quote any fiat pricing in
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getWalletBalance(address, chainIDs, fiatType, options) {
        return WalletInsightsApiFp(this.configuration).getWalletBalance(address, chainIDs, fiatType, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieve the transactions for a specific wallet
     * @summary Get wallet transactions
     * @param {string} address Wallet address or UUID
     * @param {Array<string>} [chainIDs] Filter by specific chain IDs (e.g., eip155:1, eip155:10)
     * @param {string} [pageToken] Token for pagination to get the next page of results
     * @param {number} [limit] Number of records to return per page
     * @param {Array<FiatType>} [fiatType] Fiat currency to quote any fiat pricing in
     * @param {GetWalletTransactionsTransactionVerbosityEnum} [transactionVerbosity] Option for verbosity of transaction data returned
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getWalletTransactions(address, chainIDs, pageToken, limit, fiatType, transactionVerbosity, options) {
        return WalletInsightsApiFp(this.configuration).getWalletTransactions(address, chainIDs, pageToken, limit, fiatType, transactionVerbosity, options).then((request) => request(this.axios, this.basePath));
    }
}
export const GetWalletTransactionsTransactionVerbosityEnum = {
    IncludeAllEvents: 'include_all_events',
    FilterWalletEvents: 'filter_wallet_events'
};
